<div class="container-fluid">
  <div class="header-row">
    <div class="header-left">
      <div class="header-title">
        <span>
          {{tab_name}}
        </span>
        <button *ngIf="query" (click)="toggleQueryBox()" class="btn btn-link p-0 eye-btn">
          <i class="bi" [matTooltip]="showQueryBox ? 'Hide Query' : 'View Query'"
            [ngClass]="showQueryBox ? 'bi-eye-slash' : 'bi-eye'"
            matTooltipPosition="above">
          </i>
        </button>
      </div>
  
      <div *ngIf="showQueryBox && query" class="alert alert-info query-alert" role="alert">
        {{ query || 'No query found' }}
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col m-10" style="margin:20px;">
      <div style="margin-bottom:10px;">
        The table below shows the private companies within the theme that are active with at least 1 invention in this area in the last 24 months, ranked based on the level of their innovative output in this area.
      </div>





      <div class="card keywords" style="padding:20px;">

        <h3>Private Competitors</h3>
        <div class="spinner-border text-primary" role="status" *ngIf="showSpinner">
          <span class="visually-hidden">Loading...</span>
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="top_companies_loading_failed">
          <p>
            Unfortunately, we weren't able to load the private competitors. Please try again later, or for more assistance,
            please contact
            <a href="mailto:tech@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
          </p>
        </div>
        <div class="empty-state" *ngIf="showDataMissing">
          <div class="empty-state-content">
            <i class="bi bi-search empty-state-icon"></i>
            <h4>No Companies Found</h4>
            <p>No private companies were found in this theme. You can try the Public Competitors or Custom Peer Group tabs.</p>
          </div>
        </div>

        <!-- Category Tabs inside card -->
        <div class="category-tabs" *ngIf="top_companies_data.length > 0 && !top_companies_loading_failed">
          <div class="tab-buttons">
            <button *ngFor="let category of categoryTabs" class="category-tab-btn"
              [class.active]="selectedCategory === category.key" (click)="selectCategory(category.key)">
              {{ category.label }}
            </button>
          </div>

          <!-- Category Description -->
          <div class="category-description" *ngIf="getCurrentCategoryDescription()">
            <p>
              {{ getCurrentCategoryDescription() }}
              <i class="bi bi-info-circle" [matTooltip]="getCurrentCategoryTooltip()" matTooltipPosition="above"
                style="margin-left: 8px; cursor: pointer;"></i>
            </p>
          </div>
        </div>

        <div class="filters" *ngIf="top_companies_data.length>0 && !top_companies_loading_failed">

          <mat-slide-toggle (change)="filterFavorites()">
            Show <i class="bi bi-star"></i> Selection Only
          </mat-slide-toggle>

          <div class="search-container" style="margin-left:20px; display: inline-block; position: relative;">
            <input type="text" class="form-control" placeholder="Search by Company Name" [(ngModel)]="searchQuery"
              (input)="onSearchInputChange($event)" style="width: 270px;">

            <!-- Search Spinner -->
            <div class="search-spinner" *ngIf="isSearching">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Searching...</span>
              </div>
            </div>

            <!-- Clear Search Button -->
            <button *ngIf="searchQuery && !isSearching" (click)="clearSearch()" class="clear-search-btn">
              <i class="bi bi-x-circle"></i>
            </button>
          </div>

          <!-- Result Count
          <span class="result-count" style="margin-left: 10px; color: #666; font-size: 14px;">
            {{ filteredCompanyList.length }} of {{ top_companies_data.length }} companies
          </span> -->

          <button class="btn search-button" style="margin-left:20px;background:#E5E7EB;color:#1F2937;" (click)="downloadExcel()"
            matTooltip="Download Excel">
            <i class="bi bi-download"></i>
          </button>

        </div>
        <table class="table   table-hover table-condensed "
          *ngIf="top_companies_data.length>0 && !top_companies_loading_failed">
          <thead>
            <tr style="background-color: #96c242;">
              <th scope="col" style="width: 5%;"></th>
              <th scope="col" style="width: 5%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='rank' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('rank')">
                Rank
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('rank')"></i>
              </th>

              <th scope="col" style="width: 20%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='company' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('company')">
                Company
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('company')"></i>
              </th>
              <th scope="col" style="width: 10%;">
                <div class="dropdown" style=" font-weight:normal;
">
                  <button class="btn country-dropdown-btn dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-bs-toggle="dropdown" aria-expanded="false" style="font-size: 14px;">
                    Country / <br>Market
                    <span *ngIf="(countriesControl.value?.length ?? 0) > 0" class="badge bg-light text-dark ms-1">
                      {{ countriesControl.value!.length }}
                    </span>
                  </button>
                  <div class="dropdown-menu p-3" aria-labelledby="dropdownMenuButton"
                    style="width: 270px; max-height: 300px; overflow-y: auto;">
                    <!-- Loop through each region -->
                    <div *ngFor="let region of countryFilterOptions">
                      <!-- Region Header -->
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <input type="checkbox" [checked]="isRegionFullySelected(region)"
                            (change)="toggleRegionSelection(region)" id="{{ region.region }}-region-checkbox"
                            class="form-check-input me-2">
                          <label for="{{ region.region }}-region-checkbox" class="form-check-label">
                            {{ region.region }}
                          </label>
                        </div>
                        <button class="btn btn-sm btn-light"
                          (click)="toggleExpand(region.region); $event.stopPropagation();">
                          <i class="bi" [ngClass]="isExpanded(region.region) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                        </button>
                      </div>
                      <!-- Countries in the Region -->
                      <div *ngIf="isExpanded(region.region)" class="ms-3">
                        <div *ngFor="let country of region.countries" class="form-check">
                          <input type="checkbox" class="form-check-input" [id]="'country-' + country.code"
                            [checked]="(countriesControl.value ?? []).includes(country.code)"
                            (change)="toggleCountrySelection(country.code, region)">
                          <label class="form-check-label" [for]="'country-' + country.code">
                            {{ country.name }}
                          </label>
                        </div>
                      </div>
                      <hr class="my-2" *ngIf="region !== countryFilterOptions[countryFilterOptions.length - 1]">
                    </div>
                  </div>
                </div>

              </th>


              <th scope="col" style="width: 7%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='size' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('size')"
                [ngClass]="{'column-highlight-size': selectedCategory === 'size_leaders'}">
                In Theme Size (10y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'In-Theme Invention Count (10y). Number of inventions filed by the company or its subsidiaries, published in the last 120 months, related to the selected technology. Quantifies the total size of IP assets of the company in this technology.'"
                  matTooltipPosition="above">
                </i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('size')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'size_leaders'"
                  style="color: #333; margin-left: 8px; font-size: 16px;"></i>
              </th>


              <th scope="col" style="width: 12%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='growth' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('growth')"
                [ngClass]="{'column-highlight-growth': selectedCategory === 'growth_leaders'}">
                Growth (1y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'In-Theme % Change, 1y. Percentage value showing how the innovation activity in the last year compares to the previous year in the technology. Quantifies the increase or decrease in the company\'s innovation efforts into this technology. Values in parentheses show the number of inventions published in the last 12 months.'"
                  matTooltipPosition="above">
                </i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('growth')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'growth_leaders'"
                  style="color: #333; margin-left: 8px; font-size: 16px;"></i>
              </th>

              <th scope="col" style="width: 8%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='quality' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('quality')"
                [ngClass]="{'column-highlight-quality': selectedCategory === 'quality_leaders'}">
                Quality (1y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'In-Theme, 0-100, 1y. Quant IP Quality Score is a proprietary metric to evaluate the quality of an invention upon first publication. Taking into account robustness, market potential, and citation potential, a larger average score at a company level indicates a higher patent portfolio value.'"
                  matTooltipPosition="above">
                </i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('quality')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'quality_leaders'"
                  style="color: #333; margin-left: 8px; font-size: 16px;"></i>
              </th>

              <th style="width: 7%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='total_size' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('total_size')">
                Total Size
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'Number of inventions filed by the company or its subsidiaries in all technologies over all time. Quantifies the total size of IP assets of the company.'"
                  matTooltipPosition="above">
                </i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('total_size')"></i>
              </th>

              <th style="width: 15%;" [class.sortable]="selectedCategory === 'all_competitors'"
                [class.sorted-col]="sortColumn==='innovation_score' && selectedCategory === 'all_competitors'"
                (click)="selectedCategory === 'all_competitors' && sort('innovation_score')"
                [ngClass]="{'column-highlight-innovation': selectedCategory === 'innovation_leaders'}">
                Innovation Score (0-100, 1y)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]=" 'The innovation score is a combinatorial score used for comparing the innovative strength of companies to their competitors. It takes size, growth, and quality into account and is normalized based on the peer group.'"
                  matTooltipPosition="above">
                </i>
                <i class="bi sort-icon" *ngIf="selectedCategory === 'all_competitors'"
                  [ngClass]="getSortIcon('innovation_score')"></i>
                <i class="bi bi-caret-down-fill" *ngIf="selectedCategory === 'innovation_leaders'"
                  style="color: #333; margin-left: 8px; font-size: 16px;"></i>
              </th>


              <th style="width: 11%;"> Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let company of filteredCompanyList | paginate: {id:'pag_thematic_comp', itemsPerPage: 20, currentPage: paginator_1_page }">
              <td style="    width: 70px;">
                <button (click)="toggleFavorite(company)" class="btn btn-light" style="border: none;">
                  <i class="bi" [ngClass]="company.favorite ? 'bi-star-fill text-warning' : 'bi-star'"></i>
                </button>
              </td>
              <td style="width: 70px;" [class.sorted-col]="sortColumn==='rank' && selectedCategory === 'all_competitors'">{{ company.rank }}</td>


              <td [class.sorted-col]="sortColumn==='company' && selectedCategory === 'all_competitors'">
                <div class="text" style="max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                " matTooltip="{{company.entity_name}}">
                  {{ company.entity_name }}
                </div>
                <div class="isin" *ngIf="company.isin" style="font-size: 12px;color: cadetblue;">
                  {{company.isin}} <a *ngIf="company.webpage"
                    [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                    target="_blank">
                    <i class="bi bi-box-arrow-up-right"></i>
                  </a>
                </div>
                <div class="isin" *ngIf="!company.isin" style="font-size: 12px;color: cadetblue;">
                  {{company.companytype}} <a *ngIf="company.webpage"
                    [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                    target="_blank">
                    <i class="bi bi-box-arrow-up-right"></i>
                  </a>
                </div>
              </td>
              <td [class.sorted-col]="sortColumn==='country' && selectedCategory === 'all_competitors'">{{company.country}}</td>
              <td [class.sorted-col]="sortColumn==='size' && selectedCategory === 'all_competitors'" [ngClass]="{
                    'column-highlight-size': selectedCategory === 'size_leaders'
                  }">{{ company.in_theme_invention_count_120m | nullableNumber:'1.0-0' }}</td>
              <td [class.sorted-col]="sortColumn==='growth' && selectedCategory === 'all_competitors'" [ngClass]="{
                    'column-highlight-growth': selectedCategory === 'growth_leaders'
                  }">
                <div>
                  {{ company.relative_growth_12m | nullableNumber:'1.0-1' }} %

                </div>
                <div style="font-size: 12px;color: cadetblue;"> ({{ company.invention_count_12m | nullableNumber:
                  '1.0-0' }} inventions)</div>
              </td>
              <td [class.sorted-col]="sortColumn==='quality' && selectedCategory === 'all_competitors'" [ngClass]="{
                    'column-highlight-quality': selectedCategory === 'quality_leaders'
                  }">{{company.quality_average_12m | nullableNumber:'1.0-1' }}</td>
              <td [class.sorted-col]="sortColumn==='total_size' && selectedCategory === 'all_competitors'">{{company.n_inventions | nullableNumber:'1.0-0'}}</td>

              <td [class.sorted-col]="sortColumn==='innovation_score' && selectedCategory === 'all_competitors'" [ngClass]="{
                    'column-highlight-innovation': selectedCategory === 'innovation_leaders'
                  }">
                <div class="score-bar-container">
                  <div class="score-bar">
                    <div class="score-bar-fill" [ngClass]="getBarColor(company.innovation_score)"
                      [style.width.%]="company.innovation_score"></div>
                  </div>
                  <span class="score-label">{{ company.innovation_score | nullableNumber:'1.0-1' }}</span>
                </div>
              </td>


              <td>
                <div class="action-buttons">
                
                  <button class="btn company-popup-button" style="background-color: #6c757d;"
                    (click)="openCompanyPopup(company)" matTooltip="View Company Details">
                    <i class="bi bi-search" style="color: white; font-size: 16px;"></i>
                  </button>
                  <button class="btn search-button" (click)="newSearch(company)" matTooltip="Open Company in New Tab">
                    <i class="bi  bi-box-arrow-up-right" style=" color: rgb(255, 255, 255);font-size: 18px;"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination-controls id="pag_thematic_comp" [maxSize]="5" (pageChange)="paginator_1_page = $event"
          style="align-items: flex-start;" *ngIf="filteredCompanyList.length>0">
        </pagination-controls>


      </div>
    </div>





  </div>
</div>